var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{attrs:{"data":_vm.paymentUrl,"width":"400","height":"300","type":"text/html"}},[_vm._v("\n    Alternative Content\n")])}
var staticRenderFns = []

export { render, staticRenderFns }